import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useCreateUpload = (queryClient, theme, onSuccessCallback) => {
    const { mutate: createUpload, status: createStatus, isPending: isCreating } = useMutation({
        mutationFn: (data) => api.upload.createUpload(data),
        onSuccess: (data) => {
            toast.success(data?.message || 'Upload created successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Upload creation failed', { ...toastStyles, theme: theme });
        }
    });

    return { createUpload, isCreating, createStatus };
};